export const REGULAR = {
	// amzAsin : new RegExp(/(B[\dA-Z]{9}|\d{9}(X|\d))/),
	// amzAsin : new RegExp(/B0[0-9A-Z]{8}/),
	amzAsin : new RegExp(/^[A-Z0-9]{10}$/),
	getAmzAsinByUrl : new RegExp("(https)?:\/\/(www\.)?(.*)amazon\.([a-z\.]{2,5})(\/d\/(.*)|\/(.*)\/?(?:dp|o|gp|-)\/)(aw\/d\/|product\/)?(B[\\dA-Z]{9}|\d{9}(X|\\d))")
}

export function isAsin(asin){
	return REGULAR.amzAsin.test(asin) || REGULAR.getAmzAsinByUrl.test(asin)
}

export default  REGULAR